module.exports = __webpack_public_path__ + "img/banner-principal.e9ec179b.svg";